export default "__VITE_ASSET__DaWvc3On__"